module.exports = __webpack_public_path__ + "img/cn_pocket-6.4088f45.jpg";